import { useCallback } from 'react';
import { useLocation } from 'react-router-dom';

export const CONTACT_FIRST_FIELD_ID = 'kontakt-name';

const prefersReducedMotion = () => window.matchMedia('(prefers-reduced-motion: reduce)').matches;

// Scrollt zu einer Sektion der Startseite; der Abstand zum Sticky-Header kommt aus scroll-margin-top (index.css)
export const scrollToSection = (id: string) => {
  const element = document.getElementById(id);
  if (!element) return false;
  element.scrollIntoView({ behavior: prefersReducedMotion() ? 'auto' : 'smooth', block: 'start' });
  window.history.replaceState(null, '', `#${id}`);
  return true;
};

export const useScrollToContact = () => {
  const location = useLocation();

  const scrollToContact = useCallback((e?: React.MouseEvent<HTMLAnchorElement>) => {
    // Auf Unterseiten führt der Link (/#kontakt) ganz normal zur Startseite
    if (location.pathname !== '/') return;

    e?.preventDefault();
    if (!scrollToSection('kontakt')) return;

    // Nach dem Scrollen das erste Eingabefeld fokussieren, ohne erneut zu springen
    window.setTimeout(() => {
      document.getElementById(CONTACT_FIRST_FIELD_ID)?.focus({ preventScroll: true });
    }, prefersReducedMotion() ? 0 : 700);
  }, [location.pathname]);

  return scrollToContact;
};
